var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"main_app_button",class:{ processing: _vm.processing },attrs:{"type":_vm.type,"disabled":_vm.processing},on:{"click":_vm.emitClick}},[(!_vm.processing)?_c('span',[_vm._t("default")],2):_vm._e(),(_vm.processing)?_c('div',{staticClass:"loader_ocr"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }